import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import axios from "axios";
import { useSEO } from "../lib/seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Köszönőoldal az ajánlatkérés beküldése után – Meta Pixel Lead esemény követéssel
const ThankYou = () => {
  useSEO(
    "Köszönjük az ajánlatkérést! | New Idea Architect",
    "Üzeneted megérkezett, 1 munkanapon belül felvesszük veled a kapcsolatot.",
    "/koszonjuk",
    true
  );
  useEffect(() => {
    // Egyedi event_id a böngészős pixel és a szerver oldali CAPI deduplikációjához
    const eventId = `lead-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

    // 1) Böngésző oldali Meta Pixel Lead esemény
    if (window.fbq) {
      window.fbq("track", "Lead", {}, { eventID: eventId });
    }

    // 2) Szerver oldali Meta Conversions API esemény (jobb adatminőség, ad-blocker ellenálló)
    axios
      .post(`${API}/meta/lead`, {
        event_id: eventId,
        event_source_url: window.location.href,
      })
      .catch(() => {});
  }, []);

  return (
    <main className="flex flex-col gap-2.5 pb-2.5">
      <section className="px-2.5">
        <div className="rounded-2xl bg-[var(--accent)] p-8 sm:p-14 lg:p-20 min-h-[60vh] flex flex-col items-center justify-center text-center">
          <CheckCircle2 size={64} strokeWidth={1.5} className="text-black mb-6" />
          <h1 className="text-black heading-font font-bold text-4xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.05]">
            Köszönjük az<br />ajánlatkérést!
          </h1>
          <p className="text-black font-semibold text-base sm:text-lg mt-6 max-w-md leading-6">
            Az üzeneted megérkezett hozzánk. 1 munkanapon belül felvesszük veled
            a kapcsolatot, és egyeztetünk egy díjmentes konzultációt.
          </p>
          <div className="flex flex-wrap justify-center gap-3 mt-10">
            <Link
              to="/"
              className="px-8 py-4 bg-[var(--card-dark)] text-white text-sm font-bold rounded-md hover:bg-[var(--btn-dark-hover)] transition-colors duration-200"
            >
              VISSZA A KEZDŐOLDALRA
            </Link>
            <Link
              to="/munkaink"
              className="px-8 py-4 bg-white text-black text-sm font-bold rounded-md hover:bg-[var(--card-dark)] hover:text-white transition-colors duration-200"
            >
              MUNKÁINK
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ThankYou;
